export const statusCategory = {
    DRAFT: 'Drafts',
    ENROLLED: 'Enrolment',
    WITHDRAWN: 'Withdrawn',
}